<div class="role-list-card shadow-sm p-4 bg-white rounded">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h3 class="m-0 fw-bold text-dark">Role Management</h3>
    <div class="d-flex gap-2">
      <div *ngFor="let type of projectTypes">
        <button 
          class="btn btn-sm px-3 rounded-0" 
          [class.btn-primary]="selectedClient === type.value"
          [class.btn-outline-secondary]="selectedClient !== type.value"
          (click)="switchClient(type.value)">
          {{ type.label }}
        </button>
      </div>
    </div>
  </div>

  <p-table 
    [value]="roles" 
    [loading]="loading"
    styleClass="p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th>Role Name</th>
        <th>Description</th>
        <th>Client</th>
        <th class="text-center">Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-role>
      <tr>
        <td class="fw-medium">{{ role.roleName }}</td>
        <td>{{ role.description || 'No description' }}</td>
        <td>{{ role.client }}</td>
        <td class="text-center">
          <button class="btn btn-outline-danger btn-sm rounded-0 border-0" title="Delete">
            <i class="pi pi-trash"></i>
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center py-4 text-muted">No roles found for this client.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-toast></p-toast>
